import BaseHomeSectionListRouteStore from "./BaseHomeSectionListRouteStore";

class NakiMobileEmbeddedHomeSectionListRouteStore extends BaseHomeSectionListRouteStore {
    constructor(rootStore) {
        super(rootStore);
    }
}

export default NakiMobileEmbeddedHomeSectionListRouteStore;
